/* eslint-disable */
const getPathName = (wizardTypes) => {
    for (let wizard of wizardTypes) {
        if (wizard.includes('Registration')) {
            return '/register'
        } else if (wizard.includes('Gift')) {
            return '/gift'
        } else if (wizard.includes('Checkout')) {
            return '/checkout'
        }
    }
    return '/checkout'
}

const shouldRenderBackArrow = (wizardTypes) => {
    for (let wizard of wizardTypes) {
        if (wizard.includes('Registration')) {
            return false
        }
    }
    return true
}

const navigateBack = ({ wizardTypes, popupId, router }) => {
    const pathname = getPathName(wizardTypes)

    router.replace({
        pathname,
        ...(popupId && { query: { popupId } }),
    }, {
        pathname,
        ...(popupId && { query: { popupId } }),
    })
}

const getNavigateBackButton = ({ wizardTypes, popupId, router }) => {
    let navigateButton = {}
    navigateButton.shouldRender = shouldRenderBackArrow(wizardTypes)
    navigateButton.onClick = () => navigateBack({ wizardTypes, popupId, router })

    return navigateButton
}

export {
    getNavigateBackButton,
}
